import { createSlice } from "@reduxjs/toolkit";
import { getTermsAndConditionList } from "../../reduxApi/admin/termsAndConditionsListRedux";

const termsAndConditionSlice = createSlice({
    name: 'termsAndCondition',
    initialState: {
        status: 'idel',
        isFiltered: false,
        termsAndCondition: [],
    },
    reducers: {
        setFilteredStatus: (state, action) => {
            state.isFiltered = action.payload;
        },
        deletetermsAndConditionAction: (state, action) => {
            action.payload.forEach((id) => {
                const index = state.termsAndCondition.findIndex((item) => item.ROWID === id);
                if (index !== -1) {
                    state.termsAndCondition.splice(index, 1);
                }
            });
        },
        updatetermsAndConditionAction: (state, action) => {
            const index = state.termsAndCondition.findIndex((item) => item.ROWID === action.payload.ROWID)
            if (index != -1) {
                state.termsAndCondition.splice(index, 1, { termsAndConditions: action.payload })
            }
        },
        // addtermsAndConditionAction: (state, action) => {
        //     console.log("action--->",action.payload);
            
        //     const temp = action.payload;
        //     console.log("temp",temp)
        //     temp.ROWID = action.payload.ROWID;
        //     console.log("temp.ROWID",temp.ROWID);
            
        //     state.termsAndCondition.unshift({ termsAndConditions: temp }); //add new data at beginning of array 
        // }
        addtermsAndConditionAction: (state, action) => {
            console.log("action.payload", action.payload);
            
            state.termsAndCondition.unshift(action.payload);
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getTermsAndConditionList.pending, (state, action) => {
            state.status = 'pending'
        })
            .addCase(getTermsAndConditionList.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                // state.termsAndCondition = action.payload.data.termAndConditions;
                                state.termsAndCondition = action.payload.data.termAndConditions || [];

            })
    }
})
export const { deletetermsAndConditionAction, updatetermsAndConditionAction, addtermsAndConditionAction, setFilteredStatus } = termsAndConditionSlice.actions
export default termsAndConditionSlice.reducer